import {
    CREATE_ONG,
    CREATE_ONG_SUCCESS,
    CREATE_ONG_API_ERROR,
    // GET_POSTAL_CODE,
    // GET_POSTAL_CODE_SUCCESS
} from "./actionTypes"

export const createOng = (params, callBackSuccess) => {
    return {
        type: CREATE_ONG,
        payload:{ params, callBackSuccess}
    }
}

export const createOngSuccess = data => {
    return {
        type: CREATE_ONG_SUCCESS,
        payload: { data }
    }
}

export const apicreateOngError = error => {
    return {
        type: CREATE_ONG_API_ERROR,
        payload: { error },
    }
}

// export const getPostalCode = params => {
//     return {
//         type: GET_POSTAL_CODE,
//         payload: params,
        
//     }
// }

// export const getPostalCodeSuccess = (data) => {
//     return {
//         type: GET_POSTAL_CODE_SUCCESS,
//         payload:  data 
//     }
// }